export default __webpack_public_path__ + "static/media/empty_cart.32f17a45.png";